export default __webpack_public_path__ + "static/media/avatarA7.84c5e1b3.png";